import styled from "styled-components";
import { fadeInUp, floating, rotateScaleUp } from "./styled/animations";
import { useState } from "react";

const RarityImage = styled.img`
  width: auto;
  height: 100%;
  animation: ${rotateScaleUp} 0.65s linear both;
`;

const RarityImageContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
`;

const Tooltip = styled.div`
  position: absolute;
  bottom: 100%;
  background-color: #6e4ebb;
  color: white;
  padding: 10px 15px;
  font-size: 17px;
  border-radius: 10px;
  text-align: center;
  white-space: nowrap;
  animation: ${fadeInUp} 0.4s ease-out forwards,
    ${floating} 1.5s ease-in-out infinite;

  &:after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -9px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #6e4ebb;
  }
`;

export const RarityBox = ({ src, tooltipText }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  return (
    <RarityImageContainer>
      <RarityImage
        onTouchEnd={() => setShowTooltip(false)}
        onTouchStart={() => setShowTooltip(true)}
        src={src}
      />
      {showTooltip && <Tooltip>{tooltipText}</Tooltip>}
    </RarityImageContainer>
  );
};
